import PinnedProgram from'./PinnedProgram';export default PinnedProgram;